var map = {
	"./black/lixian.png": "9Q+g",
	"./blue/lixian.png": "uUKa",
	"./white/lixian.png": "5U81"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tZP7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/lixian\.png$
// module id = tZP7
// module chunks = 24